import { Icon } from '@acme/assets';
import {
  ExchangeRateFilter,
  useCryptoCurrency,
  useCurrency,
} from '@acme/domains';
import { RangeDropdownFilter, CustomSelectDropdown } from '@acme/foundation';
import { TextInput } from 'flowbite-react';
import { useMemo, useState } from 'react';

export enum EFilterMode {
  VOLUME_SEARCH = 'VOLUME_SEARCH', // 1. Объём + Поиск
  CURRENCY_PAIR = 'CURRENCY_PAIR', // 2. Базовая валюта + Валюта котировки
  ALL_FIELDS = 'ALL_FIELDS', // 3. Все четыре поля
}

type VolumeFieldType = { from: string; to: string };

type FilterValues = ExchangeRateFilter;

interface IFilterProps {
  onChange?: (values: FilterValues) => void;
  mode: EFilterMode;
}
const defaultOption = { value: 'Все', label: 'Все' };

export const Filter = (props: IFilterProps) => {
  const { currencies } = useCurrency();
  const { currencies: cryptoCurrencies } = useCryptoCurrency();

  const currenciesOptions = useMemo(() => {
    return currencies.map((i) => {
      return {
        label: i.code || '',
        value: String(i.id || ''),
      };
    });
  }, [currencies]);

  const cryptoCurrenciesOptions = useMemo(() => {
    return cryptoCurrencies.map((i) => {
      return {
        label: i.code || '',
        value: String(i.id || ''),
      };
    });
  }, [cryptoCurrencies]);

  const [values, setValues] = useState<FilterValues>({});

  const handleChange = (field: keyof FilterValues, value: string) => {
    const newValues = { ...values, [field]: value };
    setValues(newValues);
    props.onChange?.(newValues);
  };

  const handleVolumeChange = (value: VolumeFieldType | string) => {
    const { amountMin, amountMax, ...rest } = values;

    const newValues =
      typeof value === 'string'
        ? rest
        : {
            ...rest,
            amountMin: Number(value.from),
            amountMax: Number(value.to),
          };

    setValues(newValues);
    props.onChange?.(newValues);
  };

  const renderFields = () => {
    switch (props.mode) {
      case EFilterMode.VOLUME_SEARCH:
        return (
          <>
            <RangeDropdownFilter
              label="Объём для курса"
              onChange={handleVolumeChange}
            />
            <TextInput
              className="ml-auto"
              icon={() => <Icon name="search-outline" />}
              onChange={(e) => handleChange('search', e.target.value)}
              placeholder="Наименование контрагента"
            />
          </>
        );

      case EFilterMode.CURRENCY_PAIR:
        return (
          <div className="flex items-center gap-4">
            {/* временно скрыт */}
            {/* <CustomSelectDropdown
              label="Базовая валюта"
              onChange={(val) => handleChange('currencies', val)}
              defaultOption={defaultOption}
              options={currenciesOptions}
            /> */}

            <CustomSelectDropdown
              label="Валюта котировки"
              onChange={(val) => handleChange('cryptoCurrencies', val)}
              defaultOption={defaultOption}
              options={cryptoCurrenciesOptions}
            />
          </div>
        );

      case EFilterMode.ALL_FIELDS:
        return (
          <>
            <div className="flex items-center gap-4">
              {/* временно скрыт */}
              {/* <CustomSelectDropdown
                label="Базовая валюта"
                onChange={(val) => handleChange('currencies', val)}
                defaultOption={defaultOption}
                options={currenciesOptions}
              /> */}

              <CustomSelectDropdown
                label="Валюта котировки"
                onChange={(val) => handleChange('cryptoCurrencies', val)}
                defaultOption={defaultOption}
                options={cryptoCurrenciesOptions}
              />
              <RangeDropdownFilter
                label="Объём для курса"
                onChange={handleVolumeChange}
              />
            </div>
            <TextInput
              className="ml-auto"
              icon={() => <Icon name="search-outline" />}
              onChange={(e) => handleChange('search', e.target.value)}
              placeholder="Наименование контрагента"
            />
          </>
        );
    }
  };

  return <div className="flex items-center gap-4 py-4">{renderFields()}</div>;
};
